import { db, auth } from './firebase-config';
import {
  addDoc,
  collection,
  getFirestore,
  onSnapshot,
} from "firebase/firestore";

export const getBoostCheckoutUrl = async (
  amount,
  ad_id
) => {

    console.log("Starting Boost Checkout");

  const userId = auth.currentUser?.uid;
  if (!userId) throw new Error("User is not authenticated");

  const checkoutSessionRef = collection(
    db,
    "stripe_customers",
    userId,
    "checkout_sessions"
  );

  const docRef = await addDoc(checkoutSessionRef, {
    line_items: [
      {
        price_data: {
          currency: 'usd',
          product_data: {
            name: 'Boost Post',
            description: 'Get your post seen by more people. Boost Post turns your post into a high-visibility ad, pushing it to the top of searches and into different ad slots across our platform. Choose how long you want to boost for and get more views, clicks, and engagement instantly!',
          },
          unit_amount: amount*100,
        },
        quantity: 1,
      }
    ],
    mode: 'payment',
    success_url: window.location + `/success?session_id=${ad_id}`,
    cancel_url: window.location + `/cancel?session_id=${ad_id}`,
  });

  return new Promise((resolve, reject) => {
    const unsubscribe = onSnapshot(docRef, (snap) => {
      const { error, url } = snap.data();
      if (error) {
        unsubscribe();
        reject(new Error(`An error occurred: ${error.message}`));
      }
      if (url) {
        // console.log("Stripe Checkout URL:", url);
        unsubscribe();
        resolve(url);
      }
    });
  });
};